try{Typekit.load();}catch(e){}
